import React from "react";
import Header from "../Header";
import WhiteHeaders from "../Header1";

export class WhiteLayout extends React.Component {
    state = {};

    render() {
        return (
            <>
                <WhiteHeaders />
                <div className="row justify-content-center admin-dash" style={{ marginTop: '4.5rem' }}>
                    <div className="col-md-12">
                        {this.props.children}
                    </div>
                </div>
            </>
        )
    }
}